import { ReactElement } from 'react';

import styles from './wdpLoading.module.scss';

const wdpLoading = (): ReactElement => (
  <>
    <div className={styles.loading}>
      <div className="vfH3">Loading Sponsor Data</div>
      <h4>Please wait</h4>
      <div className={`${styles.cssloadcontainer} ${styles.inline}`}>
        <div className={styles.cssloadwhirlpool} />
      </div>
    </div>
  </>
);

export default wdpLoading;
